import type { FC } from 'react';
import { useCallback } from 'react';
import type { GestureResponderEvent } from 'react-native';

import { useLikePost } from '@/features/api/hooks/grapevine-post-events/useLikePost';
import { useUnlikePost } from '@/features/api/hooks/grapevine-post-events/useUnlikePost';
import { LikeButton } from '@/features/posts/components/LikeButton';
import { isEmptyOrNull } from '@/shared/utils/string';

type LikeButtonProps = {
  postId?: string;
  liked?: boolean | null;
  likeCount?: number;
};

export const PostLikeButton: FC<LikeButtonProps> = ({
  postId = '',
  liked = false,
  likeCount = 0
}) => {
  const likePost = useLikePost();
  const unlikePost = useUnlikePost();

  const handleLikeToggle = useCallback(
    (e: GestureResponderEvent) => {
      e.preventDefault();
      if (isEmptyOrNull(postId)) return;

      if (liked) {
        unlikePost.mutate(postId);
      } else {
        likePost.mutate(postId);
      }
    },
    [postId, liked, unlikePost, likePost]
  );

  return (
    <LikeButton
      testID={`post-like-button-${postId}`}
      handleLikeToggle={handleLikeToggle}
      disabled={likePost.isPending || unlikePost.isPending}
      likeCount={likeCount}
      liked={liked}
    />
  );
};
